import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs';
import {
    COMPANY_ADDRESS,
    COMPANY_FAX,
    COMPANY_PHONE,
    FILE_ASSET_ROUTE,
    RENTAL_GUIDE_BOOK_FILE_NAME,
} from '../../../../core/constants/app.constant';
import { PRODUCT_CATEGORIES } from '../../../../core/constants/header.constant';
import { ProductCategoryEnum } from '../../../../features/admin/product/constants/product.constant';
import { UsedCategoryService } from '../../../../features/admin/product/services/used-category.service';

@Component({
    selector: 'app-footer',
    standalone: false,
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
    protected readonly COMPANY_FAX = COMPANY_FAX;
    protected readonly COMPANY_ADDRESS = COMPANY_ADDRESS;
    protected readonly COMPANY_PHONE = COMPANY_PHONE;
    protected readonly companySocialMediaList = [
        {
            link: 'https://www.instagram.com/umweepl/',
            image: '/assets/images/footer/instagram.png',
            alt: 'instagram',
        },
        {
            link: 'https://www.facebook.com/umwequipment/',
            image: '/assets/images/footer/facebook.png',
            alt: 'facebook',
        },
        {
            link: 'https://www.youtube.com/@umweepl465',
            image: '/assets/images/footer/youtube.png',
            alt: 'youtube',
        },
    ];

    protected PRODUCT_CATEGORIES = PRODUCT_CATEGORIES;

    protected productUsedCategories: ProductCategoryEnum[] = [];

    constructor(private usedCategoriesService: UsedCategoryService) {}

    get currentYear(): number {
        return new Date().getFullYear();
    }

    ngOnInit(): void {
        this.getUsedCategories();
    }

    protected checkIfCategoryExist(category: ProductCategoryEnum): boolean {
        return this.productUsedCategories.includes(category);
    }

    protected onRentalGuideBookClick(): void {
        window.open(FILE_ASSET_ROUTE + RENTAL_GUIDE_BOOK_FILE_NAME + '.pdf', '_blank');
    }

    private getUsedCategories(): void {
        this.usedCategoriesService
            .getUsedCategories()
            .pipe(take(1))
            .subscribe((response) => {
                this.productUsedCategories = response.result;
            });
    }
}
